import React, { Fragment } from 'react';

import CajaTexto from '../../components/UI/cajaTexto/cajaTexto.jsx';
import Botones from '../../components/UI/botonera/headerBotones.js';
import MonthYearPicker from '../../components/UI/dataPicker/monthYearPicker.jsx';

function CierreAnualInt(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className='row'>
                            <CajaTexto col="6" id="NumerosDel" type="text" label={props.Datos.Periodo.attributes.label} value={props.Datos.Periodo.value} attributes={props.Datos.Periodo.attributes} onChangeInput={() => {}} />
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </Fragment>
    );
}
export default CierreAnualInt;